import React, { useState, useEffect } from "react";
import ExpandableWithToggle from "../../../../components/BasicComponents/ExpandableWithToggle";

export default function MultipleValueList({
  columnName,
  selectedFilterValues,
  allOptions,
  setSelectedFilters,
  dispatchUpdateItem,
  showApplyBtn,
  filterItem,
}) {
  console.log(selectedFilterValues);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(
    Array.isArray(selectedFilterValues) ? selectedFilterValues : []
  );
  const [tempSelectedOptions, setTempSelectedOptions] = useState(
    Array.isArray(selectedFilterValues) ? selectedFilterValues : []
  );
  const [expantion, setExpantion] = useState(false);
  console.log(expantion);
  const [selectAll, setSelectAll] = useState(filterItem?.isAll ? filterItem.isAll : false);

  useEffect(() => {
    setSelectedOptions(
      Array.isArray(selectedFilterValues) ? selectedFilterValues : []
    );
    setTempSelectedOptions(
      Array.isArray(selectedFilterValues) ? selectedFilterValues : []
    );
  }, [selectedFilterValues]);

  const handleTextInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredOptions = allOptions.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (typeof option === "number") {
      return option.toString().toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });

  useEffect(() => {
    setSelectAll(
      allOptions.length > 0 && tempSelectedOptions.length === allOptions.length
    );
  }, [allOptions, tempSelectedOptions]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    if (newSelectAll) {
      // Selecting all options
      setTempSelectedOptions(allOptions);
      setSelectedOptions(allOptions);
      setSelectedFilters(allOptions);
      if (!showApplyBtn) {
        dispatchUpdateItem(allOptions, newSelectAll); // Pass the updated selectAll state
      }
    } else {
      // deSelecting all options
      setTempSelectedOptions([]);
      setSelectedOptions([]);
      setSelectedFilters([]);
      if (!showApplyBtn) {
        dispatchUpdateItem([], newSelectAll); // Pass the updated selectAll state
      }
    }
    setSelectAll(newSelectAll);
  };

  const handleCheckboxChange = (value, allOptions) => {
    const newTempSelectedOptions = tempSelectedOptions.includes(value)
      ? tempSelectedOptions.filter((item) => item !== value)
      : [...tempSelectedOptions, value];
    const isAll = newTempSelectedOptions.length === allOptions.length;
    if (showApplyBtn) {
      setTempSelectedOptions(newTempSelectedOptions);
    } else {
      setSelectedOptions(newTempSelectedOptions);
      setSelectedFilters(newTempSelectedOptions);
      dispatchUpdateItem(newTempSelectedOptions, isAll);
    }
  };

  const handleApply = (options, allOptions) => {
    const isAll = options.length === allOptions.length;
    console.log(isAll);
    setSelectedOptions(tempSelectedOptions);
    setSelectedFilters(tempSelectedOptions);
    dispatchUpdateItem(tempSelectedOptions, isAll);
    setExpantion(false);
  };

  const handleCancel = () => {
    const newTempSelectedOptions = tempSelectedOptions.slice(0, -1); // Remove the last item
    setTempSelectedOptions(newTempSelectedOptions);
    setSelectedOptions(newTempSelectedOptions);
    setSelectedFilters(newTempSelectedOptions);
    setSelectAll(false);
  };

  const formatSelectedOptions = (selectedOptions) => {
    if (!Array.isArray(selectedOptions)) return "";
    return selectedOptions.join(",");
  };

  return (
    <main className="px-1 py-1 flex flex-col overflow-y-auto w-full">
      {/* */}
      <ExpandableWithToggle
        componentType={"ASIDE3FILTERS"}
        aside3Title={`(${
          selectAll ? "All" : formatSelectedOptions(selectedOptions)
        })`}
        showApplyBtn={showApplyBtn}
        expantion={expantion}
        setExpantion={setExpantion}
      >
        <section className="w-full flex flex-col gap-1 shadow items-center justify-start rounded p-2 border-[1px]">
          <div className="flex items-center justify-center w-full">
            {/* <FaSearch className="text-gray-300" /> */}
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleTextInputChange}
              className="px-2 border rounded text-base h-7 w-full focus:outline-none font-light"
            />
          </div>
          <button
            className="flex items-center justify-left font-light w-full"
            onChange={handleSelectAll}
          >
            <input
              type="checkbox"
              id="checkbox-all"
              checked={selectAll}
              className="mr-[6px] checkbox-input"
            />
            <label
              htmlFor="checkbox-all"
              className="truncate cursor-pointer text-sm font-light"
            >
              All
            </label>
          </button>
          <div
            className={`w-full ${
              filteredOptions.length <= 4 ? "h-auto" : "h-[7rem]"
            } overflow-y-auto`}
          >
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                className="cursor-pointer flex items-center mb-1 w-full relative group truncate font-light"
              >
                <input
                  type="checkbox"
                  id={`checkbox-${index}`}
                  value={option}
                  checked={tempSelectedOptions.includes(option)}
                  onChange={() => handleCheckboxChange(option, allOptions)}
                  className="mr-[6px] checkbox-input cursor-pointer"
                />
                <label
                  htmlFor={`checkbox-${index}`}
                  className="truncate w-full text-left cursor-pointer text-sm font-light"
                >
                  {option}
                </label>
                <span
                  className={`tooltip absolute top-8 bg-black text-white shadow-lg p-[2px] rounded text-sm z-40 ${
                    option.length > 9 ? "w-32" : "w-auto"
                  } `}
                >
                  {option}
                </span>
              </div>
            ))}
          </div>

          {showApplyBtn && (
            <div className="flex justify-end items-center w-full gap-2">
              <button
                className="bg-gray-200 text-black rounded py-1 px-2 text-sm"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="bg-blue-950 text-white rounded py-1 px-2 text-sm"
                onClick={() => handleApply(tempSelectedOptions, allOptions)}
              >
                Apply
              </button>
            </div>
          )}
        </section>
      </ExpandableWithToggle>
    </main>
  );
}
